import React from "react";
import { Button } from "@mui/material";
import { FilterList as FilterListIcon } from "@mui/icons-material";

const ProductFiltersButton = ({ 
    filtersExpanded, 
    onToggle, 
    disabled = false 
}) => {
    return (
        <Button
            variant={filtersExpanded ? "contained" : "outlined"}
            startIcon={<FilterListIcon />}
            onClick={onToggle}
            disabled={disabled}
        >
            Product Filter
        </Button>
    );
};

export default ProductFiltersButton; 